import api from './api';

export async function fetchBanksCatalog() {
  const response = await api.get('/banks');

  if (!Array.isArray(response.data)) {
    throw new Error('Formato de respuesta inválido');
  }

  return response.data;
}

export function isBankInCatalog(bankId, banks) {
  if (bankId == null || bankId === '' || !Array.isArray(banks)) {
    return false;
  }

  return banks.some((bank) => String(bank.id) === String(bankId));
}
